import { createButtonInputStyleMixins } from './button-input-styles';
import { createFontStyleMixins } from './font-styles';
import { createMiscStyleMixins } from './misc-styles';
import { createModalStyleMixins } from './modal-styles';

/**
 * All Sharetribe @apply property sets (used + defined) as sx objects, keyed by set name.
 * Each value mirrors its propertySets.css block verbatim. Grown by group file, not on demand.
 * @param {Record<string,string>} tokens - createTokens() result
 * @returns {Record<string, object>}
 */
export const createMixins = (tokens) => ({
  ...createFontStyleMixins(tokens),
  ...createModalStyleMixins(tokens),
  ...createButtonInputStyleMixins(tokens),
  ...createMiscStyleMixins(tokens),
});
